import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE,
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
    COMPANY_MASTER_USERFORM_RESET,
    CREATE_COMPANY_MASTER_FAILURE,
    CREATE_COMPANY_MASTER_REQUEST,
    CREATE_COMPANY_MASTER_SUCCESS,
    CREATE_USER_FORM_COMPANY_MASTER,
    DELETE_COMPANY_MASTER_FAILURE,
    DELETE_COMPANY_MASTER_REQUEST,
    DELETE_COMPANY_MASTER_SUCCESS,
    FETCH_COMPANY_MASTER_FAILURE,
    FETCH_COMPANY_MASTER_REQUEST,
    FETCH_COMPANY_MASTER_SUCCESS,
    FETCH_SINGLE_COMPANY_MASTER_FAILURE,
    FETCH_SINGLE_COMPANY_MASTER_REQUEST,
    FETCH_SINGLE_COMPANY_MASTER_SUCCESS,
    IMAGE_UPLOAD_COMPANY_MASTER_FAILURE,
    IMAGE_UPLOAD_COMPANY_MASTER_REQUEST,
    IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
    UPDATE_COMPANY_MASTER_FAILURE,
    UPDATE_COMPANY_MASTER_REQUEST,
    UPDATE_COMPANY_MASTER_SUCCESS,
    FETCH_LOGO_COMPANY_MASTER_FAILURE,
    FETCH_LOGO_COMPANY_MASTER_REQUEST,
    FETCH_LOGO_COMPANY_MASTER_SUCCESS,
} from './companyMaster.actionsType';

// FETCH PROPERTY MASTER
export let fetchCompanyMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.companyMasterGET,
        responseTypeRequest: FETCH_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_COMPANY_MASTER_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMPANY_MASTER, updatePayload: { key, value } });
    };
};

//call property from property table
export let fetchPropertyCompanyMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/5`,
        responseTypeRequest: PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
        responseTypeSuccess: PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
        responseTypeFailure: PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE
    };
    return axiosCall(config);
};

export let fetchAreaCompanyMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.areaMasterGET}`,
        responseTypeRequest: AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
        responseTypeSuccess: AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
        responseTypeFailure: AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE
    };
    return axiosCall(config);
};

export let uploadCompanyMasterLogo = (formData, formData2) => {

    let config = {
        method: 'post',
        data: formData2,
        headers: {
            'Content-Type': 'multipart/form-data;'
        },
        // url: `${ConstantApi.companyMasterImageUpload}?FldFKCompany=${formData.get('FldFKCompany')}&FldFKUnit=${parseInt(
        //     formData.get('FldFKUnit')
        // )}&FldFKUser=${formData.get('FldFKUser')}&FldFKImageCategory=${formData.get('FldFKImageCategory')}&FldDescription=${formData.get(
        //     'FldDescription'
        // )}&FldSetAsDefault=${formData.get('FldSetAsDefault')}&FldImageCategory=${formData.get('FldImageCategory')}`,

        url: `${ConstantApi.companyMasterImageUpload}?FldFKCompany=${formData.get('FldFKCompany')}&FldFKUnit=${parseInt(
            formData.get('FldFKUnit')
        )}&FldFKUser=${formData.get('FldFKUser')}&FldFKImageCategory=${formData.get('FldFKImageCategory')}&FldDescription=${formData.get(
            'FldDescription'
        )}&FldSetAsDefault=${formData.get('FldSetAsDefault')}&FldImageCategory=${formData.get('FldImageCategory')}&FldImageCode=${formData.get(
            'FldImageCode'
        )}&FldTableName=${formData.get(
            'FldTableName'
        )}&FldControllerName=${formData.get(
            'FldControllerName'
        )}&FldReferenceId=${formData.get(
            'FldReferenceId'
        )}`,
        responseTypeRequest: IMAGE_UPLOAD_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: IMAGE_UPLOAD_COMPANY_MASTER_FAILURE,
        successMsg: 'Image upload successfully'
    };
    return axiosCall(config);
};

// CREATE PROPERTY MASTER
export let createMasterCompany = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        // fldCode: formData.code, // previously code
        fldCode: 'Auto',
        fldName: formData.name,
        fldShortName: formData.shortName,
        fldAddress1: formData.address1,
        fldAddress2: formData.address2,
        fldFKArea: parseInt(formData.area), //
        fldGSTNo: formData.gstNo,
        fldPANNo: formData.panNo,
        fldContactPerNme: formData.CName,
        fldMobileNo: formData.mobile,
        fldMailId: formData.mail,
        fldFKUnitCategory: parseInt(formData.unitType), //
        tblPropertyMasterunit: null,
        fldImagePath: formData.attachment,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4 || 'ipv4',
        fldCreatedBy: 1, //
        fldCreatedDt: today.toISOString()
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.companyMasterPOST}`,
        responseTypeRequest: CREATE_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: CREATE_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: CREATE_COMPANY_MASTER_FAILURE,
        resetFormData: COMPANY_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompanyMaster()
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCompanyMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.companyMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COMPANY_MASTER_FAILURE,
        singlApiArray: [fetchAreaCompanyMaster(), fetchPropertyCompanyMaster()]
    };
    return axiosCall(config);
};


// GET COMPANY MASTER LOGO
export let getCompanyMasterLogo = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.companyMasterGetLogo}?iCompanyID=${id}`,
        responseTypeRequest: FETCH_LOGO_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_LOGO_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_LOGO_COMPANY_MASTER_FAILURE,
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateCompanyMaster = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldCode: formData.code,
        fldName: formData.name,
        fldShortName: formData.shortName,
        fldAddress1: formData.address1,
        fldAddress2: formData.address2,
        fldFKArea: parseInt(formData.area),
        fldGSTNo: formData.gstNo,
        fldPANNo: formData.panNo,
        fldContactPerNme: formData.CName,
        fldMobileNo: formData.mobile,
        fldMailId: formData.mail,
        fldFKUnitCategory: parseInt(formData.unitType),
        tblPropertyMasterunit: null,
        fldImagePath: formData.attachment,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4 || 'ipv4',
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString()
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.companyMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_COMPANY_MASTER_FAILURE,
        resetFormData: COMPANY_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompanyMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteCompanyMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.companyMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_COMPANY_MASTER_REQUEST,
        responseTypeSuccess: DELETE_COMPANY_MASTER_SUCCESS,
        responseTypeFailure: DELETE_COMPANY_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchCompanyMaster()
    };
    return axiosCall(config);
};
